<div class="row">
  <div class="col-4">
    <rask-selector
      label="Bärighet"
      [values]="barighetItems"
      [(ngModel)]="skogsvardsAtgard.barighet"
      [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
      (change)="onMarkbehandlingChange($event)"
      bindLabel="text"
      bindValue="value"
      class="w-100">
    </rask-selector>
  </div>

  <div class="col-4">
    <rask-selector
      label="Ytstruktur"
      [values]="ytstrukturItems"
      [(ngModel)]="skogsvardsAtgard.ytstruktur"
      [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
      (change)="onMarkbehandlingChange($event)"
      bindLabel="text"
      bindValue="value"
      class="w-100">
    </rask-selector>
  </div>

  <div class="col-4">
    <rask-selector
      label="Lutning"
      [values]="lutningItems"
      [(ngModel)]="skogsvardsAtgard.lutning"
      [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
      (change)="onMarkbehandlingChange($event)"
      bindLabel="text"
      bindValue="value"
      class="w-100">
    </rask-selector>
  </div>
</div>

<div class="row">
  <div class="col-4">
    <rask-selector
      label="Markfuktighet"
      [values]="markfuktighetItems"
      [(ngModel)]="skogsvardsAtgard.markfuktighet"
      [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
      (change)="onMarkbehandlingChange($event)"
      bindLabel="text"
      bindValue="value"
      class="w-100">
    </rask-selector>
  </div>

  <div class="col-4">
    <rask-selector
      label="Kornstorlek"
      [values]="kornstorlekItems"
      [(ngModel)]="skogsvardsAtgard.kornstorlek"
      [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
      (change)="onMarkbehandlingChange($event)"
      bindLabel="text"
      bindValue="value"
      class="w-100">
    </rask-selector>
  </div>

  @if (showSkonsam()) {
    <div class="col-4" id="skonsamMarkbehandlingRBgroup">
      <rask-radiobutton-group
        label="Skonsam markbehandling"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        [(ngModel)]="skogsvardsAtgard.skonsamMarkbehandling"
        [buttons]="skonsamMarkbehandlingRadioButtons"
        (change)="onMarkbehandlingChange($event)">
      </rask-radiobutton-group>
    </div>
  }
</div>
